import revive_payload_client_4sVQNw7RlN from "/workspace/Fccs-PC-Nuxt-V3/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/workspace/Fccs-PC-Nuxt-V3/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/workspace/Fccs-PC-Nuxt-V3/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/workspace/Fccs-PC-Nuxt-V3/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/workspace/Fccs-PC-Nuxt-V3/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/workspace/Fccs-PC-Nuxt-V3/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/workspace/Fccs-PC-Nuxt-V3/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/workspace/Fccs-PC-Nuxt-V3/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_2t3e8pMCGX from "/workspace/Fccs-PC-Nuxt-V3/__nuxt_v5/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/workspace/Fccs-PC-Nuxt-V3/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import unocss_VJANGPo6Dy from "/workspace/Fccs-PC-Nuxt-V3/__nuxt_v5/unocss.mjs";
import plugin_AUP22rrBAc from "/workspace/Fccs-PC-Nuxt-V3/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import fetch_14DdzPiXUB from "/workspace/Fccs-PC-Nuxt-V3/plugins/fetch.ts";
import getInitData_rSSmlayIuW from "/workspace/Fccs-PC-Nuxt-V3/plugins/getInitData.ts";
import getImageSize_IqUjSJUwR2 from "/workspace/Fccs-PC-Nuxt-V3/plugins/getImageSize.ts";
import getInitUserInfo_Nq6IIlifFs from "/workspace/Fccs-PC-Nuxt-V3/plugins/getInitUserInfo.ts";
import echarts_HOs5L9sCmP from "/workspace/Fccs-PC-Nuxt-V3/plugins/echarts.ts";
import baiduGa_zevPSk7LXH from "/workspace/Fccs-PC-Nuxt-V3/plugins/baiduGa.ts";
import rightfixedmenu_client_DlaXztN6IH from "/workspace/Fccs-PC-Nuxt-V3/plugins/rightfixedmenu.client.ts";
import uuid_client_96aH2gX1Ut from "/workspace/Fccs-PC-Nuxt-V3/plugins/uuid.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_2t3e8pMCGX,
  prefetch_client_5tzzN0oIVL,
  unocss_VJANGPo6Dy,
  plugin_AUP22rrBAc,
  fetch_14DdzPiXUB,
  getInitData_rSSmlayIuW,
  getImageSize_IqUjSJUwR2,
  getInitUserInfo_Nq6IIlifFs,
  echarts_HOs5L9sCmP,
  baiduGa_zevPSk7LXH,
  rightfixedmenu_client_DlaXztN6IH,
  uuid_client_96aH2gX1Ut
]